import { getTaskLabelByType } from 'definitions';
import { IPackageItem } from 'pages/Packages/View/api';
import React from 'react';

interface Props {
  packageItems: IPackageItem[];
}

export function PackageItemsEarnings ({
  packageItems
}: Props) {
  const itemsWithSellerCut = packageItems.map(item => ({
    ...item,
    sellerCut: item.grossSellerEarning || 0
  }));
  const totalSellPrice = itemsWithSellerCut.reduce((acc, item) => {
    return acc + (item.price || 0) * (item.sellQuantity || 0)
  }, 0);
  const grossExpectedEarnings = itemsWithSellerCut.reduce((acc, item) => acc + item.sellerCut * item.sellQuantity, 0);
  const deductibles: Record<string, { totalDeduction: number, items: IPackageItem[] }> = itemsWithSellerCut.reduce((acc, item) => {
    [...item.preListingTasks, ...item.repairs].forEach(task => {
      if (!(task.type in acc)) acc[task.type] = { totalDeduction: 0, items: [] };
      acc[task.type].totalDeduction += task.price;
      acc[task.type].items.push(item);
    });
    return acc;
  }, {});
  const totalDeductiblePrice = Object.values(deductibles)
    .reduce((acc, item) => acc + item.totalDeduction, 0);
  const netExpectedEarnings = grossExpectedEarnings - totalDeductiblePrice;
  return (
    <div>
      <PriceRow title="Total Sell Price" price={totalSellPrice} />
      <PriceRow title="Gross Expected Earnings*" price={grossExpectedEarnings} />
      <div className='my-1'>
        {Object.entries(deductibles).map(([deductibleLabel, { totalDeduction }]) => (
          <PriceRow key={deductibleLabel} title={getTaskLabelByType(deductibleLabel)} isDeduction price={totalDeduction} />
        ))}
      </div>
      <div className='mt-1'>
        <PriceRow title="Net Expected Earnings*" price={netExpectedEarnings} />
      </div>
    </div>
  )
}

function PriceRow ({ title, price, isDeduction }: { title: React.ReactNode, price: number, isDeduction?: boolean }) {
  return (
    <div className='flex py-1'>
      <div className='flex-1 font-bold'> {title} </div>
      <div className='text-right'> {isDeduction ? '-' : null}Rs. {price} </div>
    </div>
  )
}
